/**
 * Ficha tecnica del producto, como tabla de dos columnas.
 *
 * Es una `<table>` de verdad con `<th scope="row">`: un lector de pantalla lee
 * "Codigo: EC-03416" en vez de dos textos sueltos que hay que adivinar como se
 * emparejan.
 */
export interface Especificacion {
  campo: string;
  valor: string;
}

export interface TablaEspecificacionesProps {
  especificaciones: Especificacion[];
}

export function TablaEspecificaciones({ especificaciones }: TablaEspecificacionesProps) {
  return (
    <table className="tabla-specs">
      <caption className="solo-lectores">Ficha técnica del producto</caption>
      <tbody>
        {especificaciones.map((especificacion, posicion) => (
          // La ficha escrita en el panel puede repetir un campo de los fijos.
          <tr key={`${String(posicion)}-${especificacion.campo}`}>
            <th scope="row">{especificacion.campo}</th>
            <td>{especificacion.valor}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
